import { ConfigProvider, Empty } from "antd";
import viVN from "antd/es/locale/vi_VN";
import "dayjs/locale/vi";
import { createBrowserHistory } from "history";
import React, { Suspense } from "react";
import { Provider } from "react-redux";
import {
  unstable_HistoryRouter as HistoryRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Body from "../components/Body";
import LoadingProgress from "../components/Loader/LoadingProgress";
import CheckLogin from "../components/PrivateLogin/CheckLogin";
import RoutePrivate from "../components/PrivateLogin/RoutePrivate";
import Page404 from "../pages/404page/Page404";
import { store } from "../redux/configStore";
import { dashboardTheme } from "../theme/dashboardTheme";

import ListAccout from "../pages/Content/Admin/ListAccout";
import AddPermissionInUser from "../pages/Content/Admin/components/ListPermission";
import AssetTable from "../pages/Content/Assets/AssetTable";
import CampainTable from "../pages/Content/Campains/CampainTable";
import InfoCampain from "../pages/Content/Campains/InfoCampain";
import StoreCampain from "../pages/Content/Campains/StoreCampain";
import UpdateCampain from "../pages/Content/Campains/UpdateCampain";
import CollectionTable from "../pages/Content/Collections/CollectionTable";
import CusFeeTable from "../pages/Content/Collections/CusFeeTable";
import InfoCollection from "../pages/Content/Collections/InfoCollection";
import StoreCollection from "../pages/Content/Collections/StoreCollection";
import UpdateCollection from "../pages/Content/Collections/UpdateCollection";
import InfoCustomer from "../pages/Content/Customers/CustomerInfoPage";
import CustomerTable from "../pages/Content/Customers/CustomerTable";
import GroupCustomerInfo from "../pages/Content/GroupCustomer/GroupCustomerInfo";
import GroupCustomerTable from "../pages/Content/GroupCustomer/GroupCustomerTable";
import LogActionScreen from "../pages/Content/Log/LogActionScreen";
import LogScreen from "../pages/Content/Log/LogScreen";
import MapSmsTable from "../pages/Content/MapSms/MapSmsTable";
import MapZnsTable from "../pages/Content/MapZns/MapZnsTable";
import ZnsHistories from "../pages/Content/MapZns/ZnsHistories";
import CreateMenuPage from "../pages/Content/Menu/components/CreateMenuPage";
import EditMenuPage from "../pages/Content/Menu/components/EditMenuPage";
import ListMenu from "../pages/Content/Menu/listMenu";
import OrganizationInfo from "../pages/Content/Organization/OrganizationInfo";
import OrganizationTable from "../pages/Content/Organization/OrganizationTable";
import PaymentTable from "../pages/Content/Payment/PaymentTable";
import ListPermission from "../pages/Content/Permission/ListPermission";
import CampainCustomer from "../pages/Content/Receipt/CampainCustomer";
import Receipt from "../pages/Content/Receipt/Receipt";
import ReceiptSetting from "../pages/Content/Receipt/ReceiptSetting";
import StaffTable from "../pages/Content/Staff/StaffTable";
import VoiceCallScreen from "../pages/Content/VoiceCall/VoiceCallScreen";
import VoiceHistories from "../pages/Content/VoiceCall/VoiceHistories";
import ParentCollectionDetail from "../pages/Content/Collections/ParentCollectionDetail";
import ParentCampainDetail from "../pages/Content/Campains/ParentCampainDetail";
import AccountManagement from "../pages/Content/AccountSetting/AccountManagement";
import StoreCollectionPopulation from "../pages/Content/Population/StoreCollectionPopulation";
import FeeTemplateTable from "../pages/Content/FeeTemplate/FeeTemplateTable";
import StoreFeeTemplate from "../pages/Content/FeeTemplate/StoreFeeTemplate";
import EditFeeTemplate from "../pages/Content/FeeTemplate/EditFeeTemplate";
import PaymentAccountTable from "../pages/Content/PaymentAccount/PaymentAccountTable";
import PaymentAccountEdit from "../pages/Content/PaymentAccount/PaymentAccountEdit";
import PaymentAccountCreate from "../pages/Content/PaymentAccount/PaymentAccountCreate";
import OneEduReceipt from "../pages/Content/Receipt/OneEduReceipt";
import CollectionCategoryTable from "../pages/Content/Collections/CollectionCategoryTable";

import ImportHistoryTable from "../pages/Content/Histories/ImportHistoryTable";
import InvoiceCnfTable from "../pages/Content/Invoice/InvoiceCnfTable";
import StoreInvoiceCnf from "../pages/Content/Invoice/StoreInvoiceCnf";
import InvoiceCnfTemplate from "../pages/Content/Invoice/InvoiceCnfTemplate";

import ArticleTable from "../pages/Content/Articles/ArticleTable";
import StoreArticle from "../pages/Content/Articles/StoreArticle";
import UpdateArticle from "../pages/Content/Articles/UpdateArticle";
import ReflectionTable from "../pages/Content/Reflections/ReflectionTable";
import ReflectionDetail from "../pages/Content/Reflections/ReflectionDetail";
import TicketTable from "../pages/Content/Tickets/TicketTable";
import CategoryTable from "../pages/Content/Articles/CategoryTable";
import DepartmentTable from "../pages/Content/Departments/DepartmentTable";
import BannerTable from "../pages/Content/Banners/BannerTable";
import AskQuestionTable from "../pages/Content/AskQuestions/AskQuestionTable";

const Home = React.lazy(() => import("../pages/Content/Home/Home"));
const Login = React.lazy(() => import("../pages/Login/Login"));
const StaffLogin = React.lazy(() => import("../pages/Login/StaffLogin"));
const Register = React.lazy(() => import("../pages/Register/Register"));

export const history = createBrowserHistory();
export default function RouterApp() {
  return (
    <Provider store={store}>
      <ConfigProvider
        locale={viVN}
        empty={Empty}
        /* Nguồn cấu hình antd DUY NHẤT của CMS.
           Trước đây có hai ConfigProvider lồng nhau: cái này đặt colorPrimary
           #0070D7, còn BrandedPageLayout đặt #0070D7 — nên nút primary ra màu
           khác nhau tuỳ màn có bọc layout hay không. Giờ gom về một. */
        theme={dashboardTheme}
      >
        <HistoryRouter history={history}>
          <Suspense fallback={<LoadingProgress />}>
            <Routes>
              <Route path="" element={<RoutePrivate />}>
                <Route path="" element={<Body />}>
                  <Route path="*" element={<Page404 />} />
                  <Route index element={<Home />} />

                  <Route path="/list-account" element={<ListAccout />} />
                  <Route path="/logs" element={<LogScreen />} />
                  <Route path="/action-logs" element={<LogActionScreen />} />

                  <Route path='account-setting' element={<AccountManagement />} />

                  <Route path="/customers">
                    <Route index element={<CustomerTable />} />
                    {/* Thêm mới / chỉnh sửa khách hàng làm bằng Drawer trên danh sách
                        và ngay trên màn chi tiết. Chi tiết vẫn là trang riêng vì có
                        tài sản, đợt thu, thống kê. Giữ đường cũ để link không 404. */}
                    <Route path=":id" element={<Navigate to="/customers" replace />} />
                    <Route path="information/:id" element={<InfoCustomer />} />
                  </Route>
                  <Route path="/store-customer" element={<Navigate to="/customers" replace />} />

                  <Route path="/collections">
                    <Route index element={<CollectionTable />} />
                    <Route path=":id" element={<UpdateCollection />} />
                    <Route path="information/:id" element={<InfoCollection />} />
                    <Route path="detail/:id" element={<ParentCollectionDetail />} />
                  </Route>
                   <Route path="/store-collection" element={<StoreCollection />} />
                   <Route path="/collection-categories" element={<CollectionCategoryTable />} />
                   <Route path="/store-population" element={<StoreCollectionPopulation />} />

                  <Route path="/mapzns" element={<MapZnsTable />} />
                  <Route path="/mapsms" element={<MapSmsTable />} />

                  <Route path="/payment-account">
                    <Route index element={<PaymentAccountTable />} />
                    <Route path=":id" element={<PaymentAccountEdit />} />
                  </Route>
                  <Route path="/store-payment-account" element={<PaymentAccountCreate />} />


                  <Route path="/zns-histories" element={<ZnsHistories />} />

                  <Route path="/assets">
                    <Route index element={<AssetTable />} />
                    {/* Thêm mới / chỉnh sửa / xem chi tiết tài sản làm bằng Drawer ngay
                        trên danh sách. Giữ 3 đường cũ để link/bookmark không 404. */}
                    <Route path=":id" element={<Navigate to="/assets" replace />} />
                    <Route
                      path="information/:id"
                      element={<Navigate to="/assets" replace />}
                    />
                  </Route>
                  <Route path="/store-asset" element={<Navigate to="/assets" replace />} />

                  <Route path="/payment-histories" element={<PaymentTable />} />
                  <Route path="/import-histories" element={<ImportHistoryTable />} />
                  
                  <Route path="/organizations">
                    <Route index element={<OrganizationTable />} />
                    {/* Thêm mới / chỉnh sửa đơn vị làm bằng Drawer trên danh sách.
                        Chi tiết vẫn là trang riêng vì có cán bộ, khách hàng, đợt thu.
                        Giữ đường cũ để link/bookmark không 404. */}
                    <Route path=":id" element={<Navigate to="/organizations" replace />} />
                    <Route path="information/:id" element={<OrganizationInfo />} />
                  </Route>
                  <Route path="/store-organization" element={<Navigate to="/organizations" replace />} />

                  <Route path="/customer-fees" element={<CusFeeTable />} />

                  <Route path="/voice-ip" element={<VoiceCallScreen />} />
                  <Route path="/voice-histories" element={<VoiceHistories />} />

                  <Route path="/group-customers">
                    <Route index element={<GroupCustomerTable />} />
                    <Route path="information/:id" element={<GroupCustomerInfo />} />
                    {/* Thêm mới / chỉnh sửa nhóm KH làm bằng Drawer ngay trên danh sách.
                        Giữ 2 đường cũ để link/bookmark không 404. */}
                    <Route path=":id" element={<Navigate to="/group-customers" replace />} />
                  </Route>
                  <Route
                    path="/store-group-customer"
                    element={<Navigate to="/group-customers" replace />}
                  />

                  <Route path="/campains">
                    <Route index element={<CampainTable />} />
                    <Route path=":id" element={<UpdateCampain />} />
                    <Route path="information/:id" element={<InfoCampain />} />
                    <Route path="detail/:id" element={<ParentCampainDetail />} />
                  </Route>
                  <Route path="/store-campain" element={<StoreCampain />} />


                  <Route path="/permission" element={<ListPermission />} />
                  <Route path="/menu" element={<ListMenu />} />
                  <Route path="/create-menu" element={<CreateMenuPage />} />
                  <Route path="/update-menu/:id" element={<EditMenuPage />} />
                  <Route
                    path="/add-permission/:id"
                    element={<AddPermissionInUser />}
                  />

                  <Route path="/staffs">
                    <Route index element={<StaffTable />} />
                    {/* Thêm mới / chỉnh sửa / xem chi tiết nhân sự làm bằng Drawer ngay
                        trên danh sách. Giữ 3 đường cũ để link/bookmark không 404. */}
                    <Route path=":id" element={<Navigate to="/staffs" replace />} />
                    <Route path="information/:id" element={<Navigate to="/staffs" replace />} />
                  </Route>
                  <Route path="/store-staff" element={<Navigate to="/staffs" replace />} />

                  <Route path="/templates">
                    <Route index element={<FeeTemplateTable />} />
                    <Route path=":id" element={<EditFeeTemplate />} />
                  </Route>
                  <Route path="/store-template" element={<StoreFeeTemplate />} />

                  <Route path="/invoice-accounts">
                    <Route index element={<InvoiceCnfTable />} />
                    <Route path=":id" element={<InvoiceCnfTemplate />} />
                  </Route>
                  <Route path="/store-invoice-account" element={<StoreInvoiceCnf />} />

                  <Route path="/receipt-settings" element={<ReceiptSetting />} />

                  <Route path="/articles">
                    <Route index element={<ArticleTable />} />
                    <Route path=":id" element={<UpdateArticle />} />
                  </Route>
                  <Route path="/article-categories" element={<CategoryTable />} />
                  <Route path="/store-article" element={<StoreArticle />} />

                  <Route path="/reflections">
                    <Route index element={<ReflectionTable />} />
                    <Route path=":id" element={<ReflectionDetail />} />
                  </Route>

                  {/* Yêu cầu hỗ trợ — tách khỏi Phản ánh: đếm riêng, xử lý riêng */}
                  <Route path="/tickets" element={<TicketTable />} />

                  <Route path="/departments" element={<DepartmentTable />} />

                  <Route path="/banners" element={<BannerTable />} />

                  <Route path="/ask-questions" element={<AskQuestionTable />} />

                </Route>
              </Route>
              <Route path="" element={<CheckLogin />}>
                <Route path="/login" element={<Login />} />
                <Route path="/staff-login" element={<StaffLogin />} />
                <Route path="/register" element={<Register />} />
              </Route>

              <Route path="/receipts" element={<Receipt />} />
              <Route path="/chien-dich" element={<CampainCustomer />} />
              <Route path="/onedu" element={<OneEduReceipt />} />
            </Routes>
          </Suspense>
        </HistoryRouter>
      </ConfigProvider>
    </Provider>
  );
}
